import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { productsApi } from "api/api/productsApi/productsApi";
import { GetUserMarathonProductsParams, GetUserMarathonProductsResponse } from "api/api/productsApi/types";
import { List } from "api/slice/types";

export const getUserMarathonProducts = createAsyncThunk<
  GetUserMarathonProductsResponse[],
  GetUserMarathonProductsParams
>("products/getUserMarathonProducts", async ({ marathonId, userId }, { rejectWithValue }) => {
  try {
    const data = await productsApi.getUserMarathonProducts({ marathonId, userId });
    return data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      console.error("Error while getting user marathon products", error?.response?.data);
      return rejectWithValue(error?.response?.data || "Unknown error");
    } else {
      console.error("Error while getting user marathon products", error);
      return rejectWithValue(
        "Что-то пошло не так... Попробуйте обновить страницу"
      );
    }
  }
});
